import { useState } from "react";
import { motion } from "framer-motion";
import Assessment from "./Assessment";

export default function AssessmentBanner() {
  const [open, setOpen] = useState(false);
  return (
    <section className="section bg-ink relative overflow-hidden" data-testid="assessment-banner">
      <div className="blob" style={{ width: 800, height: 800, top: "-200px", right: "-300px", background: "radial-gradient(circle, rgba(201,162,75,0.18), transparent 70%)" }} />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="border border-gold/30 bg-gradient-to-br from-gold/5 to-transparent p-10 md:p-16 relative"
        >
          <div className="text-eyebrow text-gold mb-4">Free · 3-Minute Assessment</div>
          <h2 className="font-display text-[clamp(2rem,5vw,5rem)] leading-[0.95] max-w-3xl">
            Is your dog trained — or has your dog <span className="italic gold-foil">trained you?</span>
          </h2>
          <p className="mt-6 max-w-2xl text-bone/75 font-editorial text-lg">
            Answer 9 quick questions. Get a personalized recommendation from the Wolfkeeper's playbook — no obligation, no sales pitch.
          </p>
          <button onClick={() => setOpen(true)} className="btn-gold mt-8" data-testid="assessment-open">
            Take the Free 3-Minute Assessment
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
          </button>
        </motion.div>
      </div>
      <Assessment open={open} onClose={() => setOpen(false)} />
    </section>
  );
}
